import { render, staticRenderFns } from "./IbDeleteButton.vue?vue&type=template&id=322456d2&scoped=true"
import script from "./IbDeleteButton.vue?vue&type=script&lang=js"
export * from "./IbDeleteButton.vue?vue&type=script&lang=js"
import style0 from "./IbDeleteButton.vue?vue&type=style&index=0&id=322456d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322456d2",
  null
  
)

export default component.exports